import Modal from 'src/components/ui/Modal'
import React from 'react'
import UIMessages from 'src/utils/ui-messages'
import { ITripGroupRides } from 'src/types/trip-group-rides'

export interface IConfimationDialogModalProps {
  tripsGroupRides: ITripGroupRides[]
  setIsModalOpen: (value: boolean) => void
}

const ConfimationDialogModal = (props: IConfimationDialogModalProps) => {
  const { tripsGroupRides, setIsModalOpen } = props

  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',

    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })

  const renderTable = (tripGroupRides: ITripGroupRides[]) => (
    <div className='flex flex-column w-100'>
      <div className='flex'>
        <div className='col-4 center'>
          {tripGroupRides.length > 0 && tripGroupRides[0].id ? 'Rider Type' : 'Rider Count'}
        </div>
        <div className='col-4 center'>
          {tripGroupRides.length > 0 && tripGroupRides[0].id ? 'Fare Type' : 'Payment Mode'}
        </div>
        <div className='col-4 center'>{'Total'}</div>
      </div>
      {tripGroupRides.map((item, index) => (
        <div className='flex mt1' key={index}>
          <div className='col-4 center'>{item.totalRider > 0 && `${item.totalRider} ${item.riderType}`}</div>
          <div className='col-4 center'>{item.fareType}</div>
          <div className='col-4 center'>{formatter.format(item.amount * item.totalRider)}</div>
        </div>
      ))}
    </div>
  )

  return (
    <Modal>
      <div className='fixed top-0 bottom-0 left-0 right-0 flex justify-center items-center'>
        <div className='confirmation-dialog-modal'>
          <div className='font-grey2 weight-500 modal-title'>UPDATE PASSENGER DETAILS</div>
          <div className='modal-body'>
            <div className='passenger-details-header'>
              <div className='col-12'>
                The passenger details of the trip have been successfully updated with the following details:
              </div>
            </div>
            <div className='confirmation-dialog-body'>{renderTable(tripsGroupRides)}</div>
            <div className='passenger-details-footer'>
              <button
                type='button'
                className='SaveButton inline-block btn bg-green rounded font-white weight-300 mt-auto mb-auto'
                onClick={() => setIsModalOpen(false)}
              >
                {UIMessages.common.confirm}
              </button>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  )
}

export default ConfimationDialogModal



// WEBPACK FOOTER //
// ./src/components/trips/trip-detail/confirmation-dialog-modal/ConfirmationDialogModal.tsx